import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { hasInCache } from '../src/helper/cacheHelper';
import { RotasAutenticadas} from './components/specific/rotasAutenticadas';
import { RotasNaoAutenticadas} from './components/specific/rotasNaoAutenticadas';
import './App.css';
import UsuarioDataset from './components/data/UsuarioDataSet';
import Usuario from './components/classes/Usuario';

const user = {
  isRoot: false,
  isPlanejamento: false,
  isPlanejamentoCOP: false,
  isPlanejamentoBRF: false,
  isSuporte: false,
  isSuporteCOP: false,
  isSuporteBRF: false,
  isParceiro: false,
  isBRF: false,
  isMateriaPrimaBRF: false,
  isMateriaPrimaCOP: false
};

export const UserContext = React.createContext(user); // TODO: Create context for user. Contexts can`t be created in the source file.

function App() {
  const usuarioDataSet = new UsuarioDataset();

  React.useEffect(() => {    
    const userCache: Usuario = JSON.parse(
      String(localStorage.getItem(usuarioDataSet.getKeyCach()))
    );
    
    if (userCache && userCache.regras?.length > 0) {
      montaRegras(userCache);
    }
  }, []); 

  if (hasInCache("Token")) {
    return (      
      <div className="App">
        <UserContext.Provider value={user}>
          <BrowserRouter>
            <RotasAutenticadas />
          </BrowserRouter>
        </UserContext.Provider>
      </div>      
    );
  } else {
    return (
      <div className="App">
        <BrowserRouter>
          <RotasNaoAutenticadas />
        </BrowserRouter>
      </div>
    );
  }

  function montaRegras(userCache: Usuario) {
    for (const regra of userCache.regras) {
      if (regra.descricao) {
        switch (regra.descricao) {
          case "ROOT":
            user.isRoot = true;
            user.isBRF = true;
            break;
          case "PLANEJAMENTOCOPAKER":
            user.isPlanejamento = true;
            user.isPlanejamentoCOP = true;
            user.isParceiro = true;
            break;
          case "PLANEJAMENTOBRF":
            user.isPlanejamento = true;
            user.isPlanejamentoBRF = true;
            user.isBRF = true;
            break;
          case "SUPORTECOPAKER":
            user.isSuporte = true;
            user.isSuporteCOP = true;
            user.isParceiro = true;
            break;
          case "SUPORTEBRF":
            user.isSuporte = true;
            user.isSuporteBRF = true;
            user.isBRF = true;
            break;
          case "MATERIAPRIMABRF":
            user.isMateriaPrimaBRF = true;
            user.isBRF = true;
            break;
          case "MATERIAPRIMACOPAKER":
            user.isMateriaPrimaCOP = true;
            break;
          default:
            break;
        }
      }
    }
  }
}

export default App;
